export interface Testimonial {
  name: string;
  role: string;
  avatarUrl: string;
  rating: number;
  title: string;
  content: string;
}

export const testimonials: Testimonial[] = [
  {
    name: 'Marcus Chen',
    role: 'Fashion Enthusiast, NYC',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20man%20with%20stylish%20haircut%2C%20warm%20studio%20lighting%2C%20clean%20cream%20background%2C%20modern%20portrait%20photography%2C%20natural%20expression%2C%20sharp%20detail&width=120&height=120&seq=avatar-marcus-01&orientation=squarish',
    rating: 5,
    title: 'Game-Changer for My Shopping',
    content: 'The Superbuy Spreadsheet completely transformed how I shop online. I used to spend hours searching for items, but now everything is organized and categorized perfectly. Found pieces I would have never discovered on my own. Absolutely worth it for anyone serious about fashion shopping.',
  },
  {
    name: 'Emma Richardson',
    role: 'Streetwear Collector, London',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20woman%20with%20elegant%20style%2C%20soft%20studio%20lighting%2C%20clean%20cream%20background%2C%20modern%20portrait%20photography%2C%20warm%20smile%2C%20high%20detail&width=120&height=120&seq=avatar-emma-02&orientation=squarish',
    rating: 5,
    title: 'Best Spreadsheet Resource Out There',
    content: 'I have tried several spreadsheets before, but this one stands out by miles. The QC photos linked in the spreadsheet saved me from buying low-quality items multiple times. The category organization is intuitive and the regular updates keep everything fresh.',
  },
  {
    name: 'David Park',
    role: 'Sneakerhead, Los Angeles',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Asian%20man%20with%20modern%20style%2C%20studio%20lighting%2C%20clean%20cream%20background%2C%20portrait%20photography%2C%20confident%20expression%2C%20sharp%20detail&width=120&height=120&seq=avatar-david-03&orientation=squarish',
    rating: 5,
    title: 'Found Grails I Missed Everywhere Else',
    content: 'The sneaker section in this spreadsheet is unreal. I found several pairs I had been hunting for months, all with working links and updated prices. The comparison tables help me decide between similar items quickly. This is an essential tool for any sneaker collector.',
  },
  {
    name: 'Sophie Laurent',
    role: 'Budget Shopper, Paris',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20woman%20with%20french%20style%2C%20studio%20lighting%2C%20clean%20cream%20background%2C%20portrait%20photography%2C%20gentle%20smile%2C%20elegant%20look&width=120&height=120&seq=avatar-sophie-04&orientation=squarish',
    rating: 5,
    title: 'Saved Hundreds of Dollars',
    content: 'I was skeptical at first, but the price comparison feature alone has saved me so much money. Being able to see different sellers for the same item with quality ratings is genius. The safety tips section also helped me avoid a few potential scams.',
  },
  {
    name: 'Alex Thompson',
    role: 'Reseller, Chicago',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20man%20in%20business%20casual%2C%20studio%20lighting%2C%20clean%20cream%20background%2C%20portrait%20photography%2C%20friendly%20expression%2C%20sharp%20detail&width=120&height=120&seq=avatar-alex-05&orientation=squarish',
    rating: 4,
    title: 'Perfect for Reselling Research',
    content: 'As someone who resells items, this spreadsheet is a goldmine. The trending sections help me spot what is hot before everyone else. The direct links make sourcing incredibly efficient. Only giving 4 stars because I wish there were even more categories, but what is here is excellent.',
  },
  {
    name: 'Isabella Martinez',
    role: 'Student Shopper, Miami',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20latina%20woman%20with%20warm%20smile%2C%20studio%20lighting%2C%20clean%20cream%20background%2C%20portrait%20photography%2C%20natural%20look%2C%20high%20detail&width=120&height=120&seq=avatar-isabella-06&orientation=squarish',
    rating: 5,
    title: 'My Go-To Shopping Companion',
    content: 'I am a student on a tight budget and this spreadsheet helps me find amazing deals every time. The free shipping tips and discount codes shared in the guides have been incredibly helpful. I recommend this to all my friends who shop online.',
  },
];